
export const AppMenus = {
    
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "to": "/home",
    "label": "Home",
    "icon": "pi pi-home",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "",
    "label": "Daftar Tuntutan",
    "icon": "pi pi-user-plus",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/datapetugas",
        "label": "Petugas Sekolah",
        "icon": "",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/datasukarelawan",
        "label": "Petugas Sukarelawan",
        "icon": "",
        "iconcolor": "",
        "target": "",
        
      }
    ]
  },
  {
    "to": "",
    "label": "Senarai Tuntutan",
    "icon": "pi pi-microsoft",
    "iconcolor": "",
    "target": "",
    "items": [
      {
        "to": "/tbikhtisas",
        "label": "Ikhtisas",
        "icon": "",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/tbtntperjalanan",
        "label": "Perjalanan",
        "icon": "",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/tbtntmakanbahan",
        "label": "Makan & Bahan",
        "icon": "",
        "iconcolor": "",
        "target": "",
        
      },
      {
        "to": "/tbtntsukarelawan",
        "label": "Sukarelawan",
        "icon": "",
        "iconcolor": "",
        "target": "",
        
      }
    ]
  },
  {
    "to": "/admin_akses",
    "label": "Analisis Tuntutan",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tntpetugas",
    "label": "Rumusan Tuntutan Petugas",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbpep",
    "label": "Konfigurasi",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/users",
    "label": "Pengguna",
    "icon": "pi pi-th-large",
    "iconcolor": "",
    "target": "",
    
  }
],
	statusBayaran: [    
{value: "DALAM PROSES", label: "DALAM PROSES"},
	{value: "PERAKU 2", label: "PERAKU 2"}
    ],
	statusBayaran2: [{"label":"DALAM PROSES","value":"DALAM PROSES"},{"label":"PERAKU 2","value":"PERAKU 2"}],

    exportFormats: {
        print: {
			label: 'Print',
            icon: 'pi pi-print',
            type: 'print',
            ext: 'print',
        },
        pdf: {
			label: 'Pdf',
			
            icon: 'pi pi-file-pdf',
            type: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
            icon: 'pi pi-file-excel',
            type: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
            icon: 'pi pi-table',
            type: 'csv',
            ext: 'csv',
        },
    },
    
}